export default "__VITE_ASSET__0s2tRHIn__"